import { render, staticRenderFns } from "./outstanding-bar.vue?vue&type=template&id=1ff4453e"
import script from "./outstanding-bar.vue?vue&type=script&lang=js"
export * from "./outstanding-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports